import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkdayPlanService {
    private _workDayUpdated: BehaviorSubject<number | null> = new BehaviorSubject(null);

    public get workDayUpdated$(): Observable<number> {
        return this._workDayUpdated.asObservable();
    }

    public notifyWorkDayUpdated(): void {
        // Emit timestamp to ensure a non-null value that passes the filter
        this._workDayUpdated.next(Date.now());
    }
}
